export default __webpack_public_path__ + "static/media/16.95aa1cb2.png";